import IconHOC from '../IconHOC';

import { ReactComponent as ChevronRightIcon } from './chevronRight.svg';

export const ChevronRight = IconHOC(ChevronRightIcon);
